import React from 'react';
import { App } from '../../app/AppSingleton';
import ViewModeToggle from './ViewModeToggle';
import BoardEditHeader from '../edit/BoardEditHeader';
import { SyncStatus } from '../storage/SyncStatus';
import './BoardHeader.css';
import {AppSignals} from "../../app/AppSignals";
import {Disposer} from "../../app/Signals";
import SettingsMenu from "../settings/SettingsMenu";
import {Board} from "../../models/types";

interface BoardHeaderProps {
	board:Board
}

interface BoardHeaderState {
	updated: boolean;
}

class BoardHeader extends React.Component<BoardHeaderProps, BoardHeaderState> {
	private app: App;
	private classBlock = 'board-header';
	private disposer: Disposer = new Disposer();

	constructor(props: BoardHeaderProps) {
		super(props);
		this.app = App.getInstance();
		this.state = {
			updated: false
		};
	}


	componentDidMount() {
		this.disposer.register(AppSignals.boardUpdated, () => {
			this.forceUpdate();
		});
		this.disposer.register(AppSignals.appInvalidated, () => {
			this.forceUpdate();
		});
	}

	componentWillUnmount() {
		this.disposer.dispose();
	}

	private get board() {
		return this.props.board;
	}

	private renderStandardHeader(): React.ReactNode {
		const classElement = `${this.classBlock}__content`;
		const classLeft = `${this.classBlock}__left`;
		const classRight = `${this.classBlock}__right`;
		const classTitle = `${this.classBlock}__title`;

		return (
			<header className={`${this.classBlock}`}>
				<div className={classElement}>
					{/* Левая часть: заголовок и бейдж синхронизации */}
					<div className={classLeft}>
						<h1 className={classTitle}>
							{this.board.title || 'Доска задач'}
						</h1>
					</div>

					{/* Правая часть: ViewModeToggle и SettingsMenu */}
					<div className={classRight}>
						<SettingsMenu />

						{/* Переключатель режимов просмотра */}
						<ViewModeToggle/>
					</div>
				</div>
			</header>
		);
	}

	render(): React.ReactNode {
		// Если режим редактирования активен, показываем специальный заголовок
		if (this.board.isEditing) {
			return <BoardEditHeader board={this.props.board}/>;
		}

		// Обычный заголовок с переключателем режимов
		return this.renderStandardHeader();
	}
}

export default BoardHeader;